import React from 'react';
import './landing.scss';
import Login from './Login';

const Landing:React.FC=()=> {
    return <Login/>
}

export default Landing